<template>
    <div class="examine-notice-detail">
        <div class="examin-notice-box">
            <div class="widthPC-90 margin-x-auto">
                <div class="fileNo text-right" v-if="baseInfo.fileNo">{{ baseInfo.fileNo }}</div>
                <table class="detail-table" border="1" cellspacing="0" cellpadding="0">
                    <tr>
                        <th colspan="4">建设用地规划许可</th>
                    </tr>
                    <tr>
                        <td class="font-bold">证书编号：</td>
                        <td colspan="3">{{ baseInfo.ydzId }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">项目名称：</td>
                        <td>{{ baseInfo.projectName }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">项目编号：</td>
                        <td>{{ baseInfo.projectCode }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">建设单位：</td>
                        <td><span :class="baseInfo.hasContact && curWebsite.type == 3 ? 'active-color' : ''"
                                @click="baseInfo.hasContact && curWebsite.type == 3 && handlerLinkLocal('/contact/detail?id=' + baseInfo.companyName + '&type=2')">{{
                                baseInfo.companyName || '-' }}</span></td>
                    </tr>
                    <tr>
                        <td class="font-bold">用地位置：</td>
                        <td>{{ baseInfo.location }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">用地面积：</td>
                        <td>{{ baseInfo.area || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">建设规模：</td>
                        <td>{{ baseInfo.scale || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">土地用途：</td>
                        <td>{{ baseInfo.nature || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">发证日期：</td>
                        <td>{{ baseInfo.ydzDate }}</td>
                    </tr>
                    <!-- <tr>
                    <td class="font-bold">原文链接：</td>
                    <td><a :href="baseInfo.url" target="_blank">{{ baseInfo.url }}</a></td>
                </tr> -->
                </table>
                <ad :type="2"></ad>
                <!--判断数组长度 -->
                <relatedBy v-if="extend.relatedByProjectCode && extend.relatedByProjectCode.length > 0"
                    :pageTitle="'关联项目'" :pageType="2"
                    :relatedByData="extend.relatedByProjectCode">
                </relatedBy>
                <relatedBy v-if="extend.relatedByCompanyName && extend.relatedByCompanyName.length > 0"
                    :pageTitle="'建设单位（' + baseInfo.companyName + '）关联项目'" :pageType="1" :relatedByData="extend.relatedByCompanyName">
                </relatedBy>
            </div>
        </div>
    </div>
</template>

<script>
import relatedBy from '../components/relatedBy.vue';
export default {
    components: {
        relatedBy
    },

    data() {
        return {
            id: this.$route.query.id || null,
            curWebsite: this.$api.getWebsiteType(),
            baseInfo: {
                fileNo: '',
                projectName: '',
                projectCode: '',
                approvalUnit: '',
                type: '',
                title: '',
                completionDate: ''
            },
            extend:{}
        }
    },
    created() {

    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            let ajaxUrl = this.$api.common.LandPermit.Detail() + '?id=' + this.id;
            this.$axios.get(ajaxUrl).then((res) => {
                console.log('公告数据详情', res);
                if(res.success) {
                    this.baseInfo = res.data || {};
                    this.extend = res.extend || {};
                }else {
                    this.$message.error(res.msg || '获取数据失败');
                }
                this.pageLoading = false;
            }).catch((err) => { });

        }
    }
}
</script>

<style lang="less" scoped>
.examin-notice-box {
    padding: 20px;
    width: 100%;
    background: #fff;
}

.fileNo {
    font-size: 20px;
    color: #666;
}

.detail-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;

    th {
        background: #f1f8ff;
        text-align: center;
    }

    th,
    td {
        padding: 10px;
        border: 1px solid #eee;
        min-width: 150px;
    }
}

.detail-content {
    margin-top: 20px;
    padding: 10px;
    line-height: 3;
    border: 1px solid #ebf1f5;
    box-shadow: 0 2px 4px #ebf1f5;
}
</style>